import { render } from "./BodyComponentNoTitleTable.vue?vue&type=template&id=3bd49e28&scoped=true"
import script from "./BodyComponentNoTitleTable.vue?vue&type=script&lang=js"
export * from "./BodyComponentNoTitleTable.vue?vue&type=script&lang=js"

import "./BodyComponentNoTitleTable.vue?vue&type=style&index=0&id=3bd49e28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd49e28"]])

export default __exports__